var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcn7(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e23038;}.cls-2{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.36,18.45H50.85l-3.38-6.76a5.49,5.49,0,0,0-4.93-3H27.46a5.49,5.49,0,0,0-4.93,3l-3.38,6.76H8.64A5.52,5.52,0,0,0,3.12,24V55.84a5.53,5.53,0,0,0,5.52,5.52H61.36a5.53,5.53,0,0,0,5.52-5.52V24A5.52,5.52,0,0,0,61.36,18.45ZM25.82,13.33a1.83,1.83,0,0,1,1.64-1H42.54a1.83,1.83,0,0,1,1.64,1l2.56,5.12H23.26ZM13.54,57.68H8.64A1.84,1.84,0,0,1,6.8,55.84v-23l6.74,2.92Zm3.68,0V37.4l9.69,4.19a1.83,1.83,0,0,0,.73.15h1.84V46a3.08,3.08,0,0,0,3.07,3.07h4.9A3.08,3.08,0,0,0,40.52,46V41.74h1.84a1.83,1.83,0,0,0,.73-.15l9.69-4.19V57.68ZM33.16,45.42V41.74h3.68v3.68Zm30,10.42a1.84,1.84,0,0,1-1.84,1.84h-4.9V35.81l6.74-2.92Zm0-26.95h0L42,38.07H28L6.8,28.89V24a1.84,1.84,0,0,1,1.84-1.84H61.36A1.84,1.84,0,0,1,63.2,24Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 70,
    height: 70
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcn7);
export default __webpack_public_path__ + "static/media/icn_7.7643c3f77c9c1a7c15e40302f7e2e468.svg";
export { ForwardRef as ReactComponent };